import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Grid, Paper, Skeleton } from '@mui/material';

interface OutlinedCardProps {
  nome: string;
  valor: number;
  loading: boolean;
}

const OutlinedCard1: React.FC<OutlinedCardProps> = ({ nome, valor, loading }) => {
  return (
    <Box sx={{ margin: 0.5 }}>
      <Card variant="outlined" sx={{ borderRadius: '8px' }}>
        <CardContent style={{ border: '1px solid #ccc', borderRadius: '8px', padding: '8px', display: 'flex' }}>
          <Grid marginLeft={3} item>
            <Typography sx={{ fontSize: 40, textAlign: 'center' }} >
              {loading ? <Skeleton variant="text" /> : valor}
            </Typography>
            <Typography sx={{ fontSize: 16, textAlign: 'center', }} color="text.secondary" >
              {nome}
            </Typography>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default OutlinedCard1;
